module.exports = __webpack_public_path__ + "static/adelle_semibold-webfont-woff-08e44b82dea548283c60062c5f3232ff.woff";